import SelectOption from "@/common/ui/presenters/select-option";

export default class ProjectOption implements SelectOption {
  public text: string;
  public value: string;

  public constructor(project: Project) {
    this.text = project.name;
    this.value = String(project.projectId);
  }
}

interface Project {
  projectId: number;
  name: string;
}
